import { render, staticRenderFns } from "./GradeSalary.vue?vue&type=template&id=aada6104&scoped=true&"
import script from "./GradeSalary.vue?vue&type=script&lang=js&"
export * from "./GradeSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aada6104",
  null
  
)

export default component.exports